import { useState } from 'react';
import { useTr } from '../utils/useTr';

function getArticles(tr) {
  return [
  {
    id: 'a1',
    category: tr('beewise.cat_comm'),
    title: tr('beewise.art1_title'),
    subtitle: tr('beewise.art1_sub'),
    readTime: '4 min',
    date: '2025-03-10',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&q=80&auto=format&fit=crop',
    excerpt: tr('beewise.art1_sub'),
    tags: ['messaging','first impressions','communication'],
    featured: true,
  },
  {
    id: 'a2',
    category: tr('beewise.cat_self'),
    title: tr('beewise.art2_title'),
    subtitle: tr('beewise.art2_sub'),
    readTime: '6 min',
    date: '2025-03-05',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&q=80&auto=format&fit=crop',
    excerpt: tr('beewise.art2_sub'),
    tags: ['self-awareness','friend ratings','growth'],
    featured: false,
  },
  {
    id: 'a3',
    category: tr('beewise.cat_dating'),
    title: tr('beewise.art3_title'),
    subtitle: tr('beewise.art3_sub'),
    readTime: '5 min',
    date: '2025-02-28',
    image: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=600&q=80&auto=format&fit=crop',
    excerpt: tr('beewise.art3_sub'),
    tags: ['compatibility','values','research'],
    featured: false,
  },
  {
    id: 'a4',
    category: tr('beewise.cat_flags'),
    title: tr('beewise.art4_title'),
    subtitle: tr('beewise.art4_sub'),
    readTime: '4 min',
    date: '2025-02-20',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=600&q=80&auto=format&fit=crop',
    excerpt: tr('beewise.art4_sub'),
    tags: ['kindness','green flags','dating'],
    featured: false,
  },
  {
    id: 'a5',
    category: tr('beewise.cat_dates'),
    title: tr('beewise.art5_title'),
    subtitle: tr('beewise.art5_sub'),
    readTime: '7 min',
    date: '2025-02-15',
    image: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=600&q=80&auto=format&fit=crop',
    excerpt: tr('beewise.art5_sub'),
    tags: ['montréal','first date','ideas'],
    featured: true,
  },
  {
    id: 'a6',
    category: tr('beewise.cat_comm'),
    title: tr('beewise.art6_title'),
    subtitle: tr('beewise.art6_sub'),
    readTime: '3 min',
    date: '2025-02-10',
    image: 'https://images.unsplash.com/photo-1543157145-f78c636d023d?w=600&q=80&auto=format&fit=crop',
    excerpt: tr('beewise.art6_sub'),
    tags: ['meeting IRL','timing','communication'],
    featured: false,
  },
];
}

function ArticleCard({ article, onOpen, featured }) {
  const tr = useTr();
  return (
    <div
      onClick={() => onOpen(article)}
      style={{
        background: 'var(--dark)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)', overflow: 'hidden', cursor: 'pointer',
        display: featured ? 'grid' : 'block',
        gridTemplateColumns: featured ? '1fr 1fr' : undefined,
        transition: 'transform 0.15s, border-color 0.15s',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.borderColor = 'var(--gold-border)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.borderColor = 'var(--border)'; }}
    >
      <div style={{ height: featured ? '100%' : 160, minHeight: featured ? 200 : undefined, overflow: 'hidden', position: 'relative' }}>
        <img src={article.image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        <div style={{ position: 'absolute', top: 10, left: 10, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)', padding: '0.15rem 0.5rem', borderRadius: 'var(--r-pill)' }}>
          <span style={{ fontSize: '0.6rem', color: 'var(--gold)', fontFamily: 'Outfit', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' }}>{article.category}</span>
        </div>
      </div>
      <div style={{ padding: '0.9rem 1rem' }}>
        <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: featured ? '1.2rem' : '1.05rem', fontWeight: 500, color: 'var(--white)', lineHeight: 1.25, marginBottom: '0.3rem' }}>{article.title}</h3>
        <p style={{ fontSize: '0.7rem', color: 'var(--muted)', lineHeight: 1.5, marginBottom: '0.6rem' }}>{article.subtitle}</p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '0.6rem', color: 'var(--muted)', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            {tr('beewise.read_time',{n:article.readTime.split(' ')[0]})}
          </span>
          <span style={{ fontSize: '0.58rem', color: 'var(--muted)', opacity: 0.6 }}>·</span>
          <span style={{ fontSize: '0.6rem', color: 'var(--muted)' }}>{new Date(article.date).toLocaleDateString('en-CA', { month: 'short', day: 'numeric' })}</span>
        </div>
      </div>
    </div>
  );
}

function ArticleModal({ article, onClose }) {
  const tr = useTr();
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 800, background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'var(--black)', border: '1px solid var(--border)', borderRadius: 'var(--r-xl) var(--r-xl) 0 0', maxWidth: 480, width: '100%', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ height: 200, position: 'relative', flexShrink: 0 }}>
          <img src={article.image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, transparent 30%, rgba(0,0,0,0.8))' }} />
          <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 12, width: 32, height: 32, borderRadius: '50%', background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.2)', color: 'var(--white)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>✕</button>
          <div style={{ position: 'absolute', bottom: 14, left: 16, right: 16 }}>
            <span style={{ fontSize: '0.6rem', color: 'var(--gold)', fontFamily: 'Outfit', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase' }}>{article.category}</span>
            <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: '1.4rem', fontWeight: 500, color: 'var(--white)', lineHeight: 1.2, marginTop: '0.2rem' }}>{article.title}</h2>
          </div>
        </div>
        <div style={{ overflowY: 'auto', flex: 1, padding: '1.2rem 1.2rem 2rem' }}>
          <p style={{ fontSize: '0.82rem', color: 'var(--muted)', lineHeight: 1.65, marginBottom: '1.2rem', fontStyle: 'italic' }}>{article.subtitle}</p>
          <p style={{ fontSize: '0.88rem', color: 'var(--white)', lineHeight: 1.75 }}>{article.excerpt}</p>
          <div style={{ margin: '1.5rem 0', height: 1, background: 'var(--border)' }} />
          <p style={{ fontSize: '0.82rem', color: 'var(--white)', lineHeight: 1.75 }}>
            Every relationship starts with curiosity — a genuine desire to understand another person beyond their surface.
            The best daters aren't the most charming or the most attractive. They're the most curious.
            They ask follow-up questions. They remember details. They make the other person feel seen.
          </p>
          <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap', marginTop: '1.2rem' }}>
            {article.tags.map(t => (
              <span key={t} style={{ fontSize: '0.62rem', padding: '0.15rem 0.5rem', background: 'var(--gold-pale)', border: '1px solid var(--gold-border)', borderRadius: 'var(--r-pill)', color: 'var(--gold)', fontFamily: 'Outfit' }}>{t}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function BeeWise() {
  const tr = useTr();

  const [category, setCategory] = useState(tr('beewise.cat_all'));
  const [openArticle, setOpenArticle] = useState(null);

  const filtered = category === 'All' ? ARTICLES : ARTICLES.filter(a => a.category === category);
  const featured = filtered.filter(a => a.featured);
  const regular  = filtered.filter(a => !a.featured);

  return (
    <div style={{ paddingBottom: '1rem' }}>
      {/* Header */}
      <div style={{ padding: '1.5rem 1.2rem 1rem', borderBottom: '1px solid var(--border)' }}>
        <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: '1.8rem', fontWeight: 400, color: 'var(--white)', marginBottom: '0.2rem' }}>
          Bee <span style={{ color: 'var(--gold)', fontStyle: 'italic' }}>Wise</span>
        </h1>
        <p style={{ fontSize: '0.78rem', color: 'var(--muted)' }}>{tr('beewise.subtitle')}</p>
      </div>

      {/* Category filters */}
      <div style={{ display: 'flex', gap: '0.4rem', overflowX: 'auto', padding: '0.8rem 1.2rem', scrollbarWidth: 'none', borderBottom: '1px solid var(--border)' }}>
        {CATEGORIES.map(cat => (
          <button key={cat === 'All' ? tr('beewise.cat_all') : cat} onClick={() => setCategory(cat)} style={{ flexShrink: 0, padding: '0.28rem 0.7rem', border: `1px solid ${category === cat ? 'var(--gold)' : 'var(--border)'}`, borderRadius: 'var(--r-pill)', background: category === cat ? 'var(--gold-pale)' : 'transparent', color: category === cat ? 'var(--gold)' : 'var(--muted)', fontFamily: 'Outfit', fontSize: '0.68rem', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
            {cat === 'All' ? tr('beewise.cat_all') : cat}
          </button>
        ))}
      </div>

      {/* Featured */}
      {featured.length > 0 && (
        <div style={{ padding: '1rem 1.2rem 0' }}>
          <p style={{ fontSize: '0.58rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '0.7rem', fontFamily: 'Outfit', fontWeight: 600 }}>{tr('beewise.featured')}</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.2rem' }}>
            {featured.map(a => <ArticleCard key={a.id} article={a} onOpen={setOpenArticle} featured />)}
          </div>
        </div>
      )}

      {/* Regular grid */}
      <div style={{ padding: '0.5rem 1.2rem', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
        {regular.length > 0 && <p style={{ fontSize: '0.58rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--muted)', fontFamily: 'Outfit', fontWeight: 600 }}>{tr('beewise.more')}</p>}
        {regular.map(a => <ArticleCard key={a.id} article={a} onOpen={setOpenArticle} />)}
      </div>

      {openArticle && <ArticleModal article={openArticle} onClose={() => setOpenArticle(null)} />}
    </div>
  );
}
